<template>
  <div class="content_main">
    <p class="content_normal">We act as Solicitors to CASHIGO INTERNATIONAL LIMITED, who will shall
      hereafter refer to as Our Client and on whose instruction we now write.</p>
    <br />
    <p class="content_normal">Since the loan you are applied for on our platform LCredit has been
      overdue for more than 21 days, All effort to reach you to negotiate the loan prove abortive.
      Our company initially judged that you were unable to repay the loan, and suspected that you
      try to deceive the company and maliciously default on the loan, our company has the right to
      freeze your bank account and Bvn.</p>
    <br />
    <p class="content_normal">The company will keep calling more of your contact, friends and family
      to report the situation to them.</p>
    <br />
    <p class="content_normal">In order to avoid affecting your reputation, please repay the loan as
      soon as possible after receiving the notice or contact us. If you have financial difficulties,
      we can apply for a 30% penalty interest reduction for you. After you have completed the
      repayment, if there is still a need for borrowing, you can apply for another loan</p>
    <br />
    <p class="content_normal">After receiving the information, please contact my whatsapp:
      08120570894</p>
    <p class="content_normal">Email: lcredit@firchinternational.com</p>
    <br />
    <p class="content_normal">Therefore, this letter requires you to pay and return it to the mail
      or company immediately.</p>
    <br />
    <p class="content_normal">Regards. Therefore, this letter requires you to pay and return it to
      the mail or company immediately.</p>
    <br />
    <p class="content_normal">Note: If you fail to pay, we will use all available methods to seek
      justice, which will obviously make you pay more.</p>
    <br />
    <p class="content_normal">While waiting for your prompt reply, do have the assurance of our best
      regards.</p>
    <br />
    <p class="content_normal">Regards.</p>
    <br />
    <p class="content_normal">NOTE: Where you fail to make payment, we shall use all available means
      to get justice for our client which will obviously cost you more.</p>
    <br />
    <p class="content_normal">While waiting for your prompt response do have the assurance of our
      beat regards.</p>
    <br />
    <p class="content_normal">Yours Faithfully.</p>

  </div>
</template>

<script>
export default {
  name: 'M4',
};
</script>

<style lang="stylus" scoped>
px = (1 / 24.75vw);
.content {
  padding: 25 *px 16 *px;
  .content_main{
    line-height: 20px;
    text-indent: 16px;
    margin-top: 16px;
  }
  .content_normal {
    text-align: left;
    text-indent: 16px;
  }
}
</style>
